import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FilterOptions } from '@hero/components/molecules/Table/Filter/context';
import { constants } from '@hero/configs';
import { useIsAdminOrganization, useRecognitionTableFilterOptions } from '@hero/hooks';
import { TableSelectFilter } from '@hero/molecules';
import { useGetOrganizationUsers } from '@hero/services/organization-service/hooks';
import { getName } from '@hero/utils';

import * as S from './style';

function Filter({ globalFilters, placeholder, setGlobalFilters }) {
  const { t } = useTranslation();
  const recognitionFilterOptions = useRecognitionTableFilterOptions();
  const isOrganizationAdmin = useIsAdminOrganization();
  const hasMultipleApps = constants.apps?.length > 1;

  const { data: organizationUsers } = useGetOrganizationUsers(
    {
      filters: {
        statuses: ['active']
      }
    },
    {
      enabled: !!isOrganizationAdmin
    }
  );

  return (
    <S.FilterWrapper>
      {t('filterBy')}:
      <FilterOptions.Provider
        value={{
          inputPlaceholderOnMenu: placeholder,
          hideSearchOnMenu: true
        }}
      >
        <TableSelectFilter
          isMulti
          options={recognitionFilterOptions}
          onChange={filters => {
            setGlobalFilters(passValues => ({
              ...passValues,
              filters: {
                ...passValues.filters,
                status: filters
              }
            }));
          }}
          selectedOption={globalFilters?.filters?.status}
          placeholder={t('status')}
          hasMenuSearch={false}
        />

        {hasMultipleApps && (
          <TableSelectFilter
            isMulti
            options={constants.apps.map(app => ({
              label: app.name,
              value: app.id
            }))}
            onChange={filters => {
              setGlobalFilters(passValues => ({
                ...passValues,
                filters: {
                  ...passValues.filters,
                  source: filters
                }
              }));
            }}
            selectedOption={globalFilters?.filters?.source}
            placeholder={t('source')}
            hasMenuSearch={false}
          />
        )}
        {isOrganizationAdmin && (
          <TableSelectFilter
            isMulti
            options={organizationUsers?.docs?.map(user => ({
              label: getName({ firstName: user.firstName, lastName: user.lastName }),
              value: user.email
            }))}
            onChange={filters => {
              setGlobalFilters(passValues => ({
                ...passValues,
                filters: {
                  ...passValues.filters,
                  createdBy: filters
                }
              }));
            }}
            selectedOption={globalFilters?.filters?.createdBy}
            placeholder={t('sender')}
            searchPlaceholder={`${t('searchSenders')}...`}
          />
        )}
      </FilterOptions.Provider>
    </S.FilterWrapper>
  );
}

Filter.propTypes = {
  globalFilters: PropTypes.shape({
    filters: PropTypes.shape({
      status: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      source: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      createdBy: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    })
  }),
  placeholder: PropTypes.string,
  setGlobalFilters: PropTypes.func
};

export { Filter };
